<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('recipe:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="审核时间">
                <a-date-picker style="width: 100%" placeholder="请选择审核时间"  @change="onChangeverifytime"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="处方类别">
                <!-- <a-input v-model="queryParam.category" allow-clear placeholder="请输入处方类别"/> -->
                <a-select v-model="queryParam.category"  allow-clear placeholder="请选择处方类别" :options="category"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单状态">
                <!-- <a-input v-model="queryParam.recipeNo" allow-clear placeholder="请选择订单状态" /> -->
                <a-select v-model="queryParam.orderState" allow-clear placeholder="请选择订单状态" :options="orderstates"></a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="是否外配">
                  <!-- <a-input v-model="queryParam.orderstate" allow-clear placeholder="请输入订单状态"/> -->
                  <a-select v-model="queryParam.nf" allow-clear placeholder="请选择订单状态" :options="deliveryWay"></a-select>
                </a-form-item>
              </a-col>
              
              
              <a-col :md="8" :sm="24">
                <a-form-item label="姓名">
                  <a-input v-model="queryParam.patientName" allow-clear placeholder="请输入姓名"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="病人ID">
                  <a-input v-model="queryParam.patientId" allow-clear placeholder="请输入病人ID"/>
                </a-form-item>
              </a-col>
             <a-col :md="8" :sm="24">
                <a-form-item label="处方流水号">
                  <a-input v-model="queryParam.recipeNo" allow-clear placeholder="请输入处方流水号"/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
      <template class="table-operator" slot="operator">
        <!-- <template class="table-operator" slot="operator" v-if="hasPerm('recipe:add')" > -->
          <!-- <a-button type="primary" v-if="hasPerm('recipe:add')" icon="plus" @click="$refs.addForm.add()">新增recipe</a-button> -->
          <!-- <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('recipe:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button> -->
          <!-- <x-down
            v-if="hasPerm('recipe:export')"
            ref="batchExport"
            @batchExport="batchExport"
          /> -->
          <a-tooltip placement="top">
            <a-button type="dashed" @click="batchPrint">打印小票</a-button>
          </a-tooltip>
        </template> 

        <span slot="category" slot-scope="text, record">
            {{record.category == '1'? '西药/中成药' : '中药处方'  }}
        </span>
        <span  slot="patientsex" slot-scope="text, record">
            {{record.patientsex == '1'? '男' : '女'  }}
        </span>

        <span slot="deliveryWay" slot-scope="text, record" >
            {{ record.deliveryWay == '0' ? '物流配送' : record.deliveryWay == '1' ? '自提' : record.deliveryWay == '2' ? '外配' : '' }}
        </span>

        <span slot="orderstate" slot-scope="text, record" >
            {{ record.negotiationFlag == 0 && record.orderstate == '2' ? '待发药' : record.negotiationFlag == 0 && record.orderstate == '10' ? '已发药' : record.negotiationFlag == 1 && record.orderstate == '2' ? '----' : record.negotiationFlag == 1 && record.orderstate == '10' ? '----' : record.orderstate == '2' ? '待发药' :  record.orderstate == '10' ? '已发药' : record.orderstate == '8' ? '已发药' : record.orderstate == '9' ? '已完成' : '' }}
        </span>


        <span slot="packageStatus" slot-scope="text, record" :class="record.packageStatus == 1 ? 'infoStyle' : ''"  v-if="record.deliveryWay == '0'">
            {{ record.packageStatus == '0'? '未预约' : record.packageStatus == '1'? '已预约' : record.packageStatus == '2'? '取消预约' : ''  }}
        </span>
        <span slot="packageStatus" slot-scope="text, record" :class="record.orderstate == 9 ? 'infoStyle' : ''"  v-else-if="record.deliveryWay == '1' ">
            {{ record.orderstate == '9'? '自提成功' : '等待自提'  }}
        </span>
        <span slot="packageStatus" slot-scope="text, record" :class="record.packageStatus == 1 ? 'infoStyle' : ''"  v-else-if="record.deliveryWay == '2'">
        
        </span>


        <span slot="action" slot-scope="text, record" v-if="record.deliveryWay !== '2' ">

          <!-- 物流 待发药状态 -->
          <a v-if="record.orderstate == '2' ">
              <a style="margin-left:10px" @click="$refs.addForm.add(record,true,record.deliveryWay)">在线发药</a>
          </a>
          <!-- 物流 已发药状态 -->
          <a v-else-if="record.orderstate == '8'">
              <a @click="$refs.addForm.add(record,false,record.deliveryWay)">详情</a> 
              <a v-if="record.packageStatus != 1 " style="margin-left:10px" @click="$refs.orderForm.add(record)" >预约寄件</a>
              <a v-if="record.packageStatus == 1 " style="margin-left:10px" @click="$refs.sendForm.add(record)" >查看物流</a>
              <!-- <a style="margin-left:10px">处方下载</a> -->
          </a>
             <!-- 自提 待发药状态 -->
           <a v-else-if="record.orderstate == '10'" >
              <a @click="$refs.addForm.add(record,false,record.deliveryWay)">详情</a> 
              <a  style="margin-left:10px" @click="setWeight(record)" >取药</a>
              <!-- <a style="margin-left:10px">处方下载</a> -->
          </a>
             <!-- 自提 已发药状态 -->
          <a v-else-if="record.orderstate == '9'" >
              <a  style="margin-left:10px" @click="$refs.addForm.add(record,false,record.deliveryWay)">详情</a> 
          </a>
        </span>

        <span slot="action" slot-scope="text, record" v-else>
          <a style="margin-left:10px" @click="$refs.addForm.add(record,false,record.deliveryWay)">详情</a>
        </span>

      </s-table>
      
      <edit-form ref="editForm" @ok="handleOk" />
      
    </a-card>

      <a-modal v-model="weight" title="自提取药" @ok="weightOk" @cancel="handleWeight">
      <a-row :gutter="24">
        <a-col :md="20">
          <a-form-item label="*自提码" :labelCol="{xs: { span: 24 },sm: { span: 4 }}"
            :wrapperCol="{xs: { span: 24 },sm: { span: 16 }}">
            <a-input v-model="sortWeight" allow-clear placeholder="请输入6位自提码进行验证" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-modal>

    <add-form ref="addForm" @ok="handleOk" />
    <send-form  ref="sendForm" @ok="handleOk"></send-form>
    <order-form  ref="orderForm" @ok="handleOk"></order-form>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { recipePage, recipeDelete, recipeExport, recipePickupCode } from '@/api/modular/interhospital/recipetable/recipeManage'
  import addForm from './viewDetial.vue';
  import editForm from './editForm.vue';
  import sendForm from './express.vue';
  import orderForm from './orderMail.vue';
  export default {
    components: {
      STable,
      addForm,
      editForm,
      sendForm,
      orderForm,
      XDown
    },
    data () {
      return {
         weight: false,
         sortWeight : '',
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          nf : '0'
        },
        // 表头
        columns: [
          {
            title: '审核时间',
            align: 'center',
            dataIndex: 'verifytime'
          },
          {
            title: '处方流水号',
            align: 'center',
            dataIndex: 'recipeno'
          },
          {
            title: '处方类别',
            align: 'center',
            dataIndex: 'category',
            scopedSlots: { customRender: 'category' },
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'patientname'
          },
          {
            title: '性别',
            align: 'center',
            dataIndex: 'patientsex',
            scopedSlots: { customRender: 'patientsex' },
          },
          {
            title: '年龄',
            align: 'center',
            dataIndex: 'patientage'
          },
          {
            title: '病人ID',
            align: 'center',
            dataIndex: 'patientid'
          },
          {
            title: '发药方式',
            align: 'center',
            dataIndex: 'deliveryWay',
            scopedSlots: { customRender: 'deliveryWay' },
          },
          {
            title: '订单状态',
            align: 'center',
            dataIndex: 'orderstate',
            scopedSlots: { customRender: 'orderstate' },
          },
          {
            title: '预约状态',
            align: 'center',
            dataIndex: 'packageStatus',
            scopedSlots: { customRender: 'packageStatus' },
          },
          {
            title: '操作',
            align: 'center',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],
        orderstates : [
          {
            value: '2',
            label: '待发药',
          },
          {
            value: '10',
            label: '自提已发药',
          },
          {
            value: '8',
            label: '物流配送已发药',
          },
          {
            value: '9',
            label: '已完成',
          },
        ],
        category : [
          {
            value: '1',
            label: '西药/中成药',
          },
          {
            value: '2',
            label: '中药处方',
          },
        ],
        deliveryWay: [
          {
            value: '0',
            label: '否',
          },
          {
            value: '1',
            label: '是',
          },
        ],
        
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData:  parameter => {
          return  new Promise(async(resolve,reject)=>{
              const res = await recipePage(Object.assign(parameter, this.switchingDate()));
              resolve(res.data)
          });
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamverifytime = this.queryParam.verifytimeDate
        if (queryParamverifytime != null) {
            this.queryParam.verifytime = moment(queryParamverifytime).format('YYYY-MM-DD')
            if (queryParamverifytime.length < 1) {
                delete this.queryParam.verifytime
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'id': record.id }]
        this.recipeDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        this.recipeDelete(paramIds)
      },
      recipeDelete (record) {
        recipeDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      onChangeverifytime(date, dateString) {
        this.queryParam.verifyTime = dateString;
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        recipeExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      batchPrint(){
        
        if(this.selectedRows.length==0){
          this.$message.warning('请选择处方数据')
        }else if(this.selectedRows.length==1){
           console.log('选择的处方',this.selectedRows)
          // if(this.selectedRows[0].orderstate == '10'||this.selectedRows[0].orderstate == '8'){
            let recipeId = this.selectedRows[0].recipeId
            window.open(`https://interhospital.youjiankang.net/printTicket/printTicket.html?id=${recipeId}`)
          // }else{
          //   this.$message.warning('请选择已发药处方')
          // }
        }else if(this.selectedRows.length>1){
          this.$message.warning('只能选择一个处方')
        }
      },
        /**
       * 点击发药确认自提码
       */
      sendMedia(){
        // recipePickupCode
      },
      setWeight(record) {
        this.record = record;
        this.weight = true;
      },
       // 权重设置
      weightOk() {
        let params = {
          orderId: this.record.id,
          pickUpCode: this.sortWeight
        }
        recipePickupCode(params).then(res => {
          if (res.code == 200) {
            this.weight = false;
            this.handleOk();
            this.$message.success('自提成功')
          } else {
            this.weight = false;
            this.$message.error(res.message)
          }
        })
        
      },
      handleWeight() {
        this.weight = false;
        this.handleOk();
      },



      
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
  .infoStyle{
    color: #1890FF
  }
</style>
